module.exports = __webpack_public_path__ + "static/img/专业熔炼设备.17ecef1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/专业熔炼设备.jpg
// module id = 2gr5
// module chunks = 1